import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { InlineLinkDarkControl as InlineLink } from '../controls/inline-link-control';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  The location you clicked is outside of the Melbourne Strategic Assessment program area. Click within the MSA levy area
  to calculate a levy liability estimate for a parcel.
    </p>
    <p>
  If you wish to determine offset obligations outside the MSA program area, please proceed to the{' '}
  <InlineLink href="https://nvim.delwp.vic.gov.au/Biodiversity" text="Native Vegetation Removal Regulations" mdxType="InlineLink" />{' '}
  tool.
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      